import { render, staticRenderFns } from "./UserDetailsAndLicensesDialog.vue?vue&type=template&id=63f7aa20&scoped=true"
import script from "./UserDetailsAndLicensesDialog.vue?vue&type=script&lang=js"
export * from "./UserDetailsAndLicensesDialog.vue?vue&type=script&lang=js"
import style0 from "./UserDetailsAndLicensesDialog.vue?vue&type=style&index=0&id=63f7aa20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f7aa20",
  null
  
)

export default component.exports